import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { LocationsByRegionDto } from '../models/locations/location.models';

@Injectable()
export class LocationService {
    constructor(private http: GlobalHttpClient) {
    }

    getActiveLocations(): Observable<LocationsByRegionDto> {
        var response = this.http.get<LocationsByRegionDto>('locations/getactive');

        return response;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/location.service.ts